import { DiscoveredApp } from '@/types/Responses/App.ts';
import { useAuthStore } from '@/stores/auth.ts';
import { Header } from '@/types/Header.ts';

export const callDiscoverableApp = async (url: string): Promise<DiscoveredApp[]> => {
	const commonHeaders: Header = {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		Cache: 'default',
		Authorization: `Bearer ${useAuthStore().token}`,
	};

	try {
		const response = await fetch(url, {
			method: 'GET',
			headers: commonHeaders,
		});
		const json = await response.json();
		if (response.status !== 200) {
			return [];
		}
		return json.data as DiscoveredApp[];
	} catch (error) {
		console.error(`Error in discovering app: ${error}`);
		return [];
	}
};

export default {
	callDiscoverableApp,
};
